<template>
  <main>
    <section class="banner">
      <div class="container">
        <div class="circle">
          <div class="box">
            <h2 class="banner-subtitle">Olá, me chamo</h2>
            <h1
              class="banner-title"
              data-cursor-hover
              data-cursor-mix-blend-mode="difference"
            >
              Wilker Lopes
            </h1>
            <h2 class="banner-subtitle">desenvolvedor Full Stack</h2>
          </div>
        </div>

        <a
          href="#about"
          class="btn-scroll"
          data-cursor-hover
          data-cursor-mix-blend-mode="difference"
          title="Scroll"
        />
      </div>
    </section>

    <section id="about" class="about">
      <div class="container">
        <h1
          class="title dot center"
          data-cursor-hover
          data-cursor-mix-blend-mode="difference"
        >
          Sobre
        </h1>
        <div class="center">
          <p class="text">
            Sempre buscando uma forma de aprender um pouco mais, seja pela
            experiência profissional ou por projetos proprios. Assim a cada dia
            produzo códigos mais limpos e sofisticados. Depois de um desafio,
            amei trabalhar com vue.js
          </p>
        </div>
      </div>
    </section>

    <section class="skill">
      <div class="container">
        <h1
          class="title dot center"
          data-cursor-hover
          data-cursor-mix-blend-mode="difference"
        >
          Skils
        </h1>
        <div class="center">
          <p class="text">Um pouco do que eu aprendi.</p>

          <div class="box-skill">
            <vs-row>
              <vs-col
                w="6"
                sm="12"
                v-for="(side, index) in skillsTabs"
                :key="index"
              >
                <div class="item" v-for="(item, index) in side" :key="index">
                  <div class="name">{{ item.name }}</div>
                  <div class="line" :class="[item.habilities]"></div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>
    </section>

    <section class="projects">
      <div class="container">
        <h1
          class="title center"
          data-cursor-hover
          data-cursor-mix-blend-mode="difference"
        >
          Projetos
        </h1>
        <div class="grid-container">
          <div
            :class="['card' + card.id, card.id == 1 ? 'square' : 'rect']"
            v-for="card in projects"
            :key="card.id"
          >
            <div class="box-ratio">
              <vs-card
                type="2"
                data-cursor-hover
                data-cursor-mix-blend-mode="difference"
              >
                <template #title class="d-flex">
                  <h1 class="card-title">
                    {{ card.title }}

                    <vs-button
                      v-if="card.link"
                      shadow
                      blank="true"
                      :href="card.link"
                      size="mini"
                      circle
                    >
                      Ver mais
                      <ion-icon
                        name="arrow-forward-outline"
                        class="thin large color-2"
                      ></ion-icon>
                    </vs-button>
                  </h1>
                </template>
                <template #img>
                  <img :src="card.image" :alt="card.title" loading="lazy" />
                </template>
                <template #text>
                  <p>{{ card.description }}</p>
                  <p class="status">{{ card.status }}</p>
                </template>
                <template #interactions>
                  <div class="contributors">
                    <vs-avatar-group max="3">
                      <vs-avatar
                        v-for="(avatar, index) in card.contributors"
                        :key="index"
                        @click="opemLink(avatar.link)"
                      >
                        <img :src="avatar.picture" :alt="avatar.name" />
                      </vs-avatar>
                    </vs-avatar-group>
                  </div>

                  <div class="languages">
                    <vs-tooltip
                      v-for="(lang, index) in card.stack"
                      :key="index"
                    >
                      <vs-button
                        primary
                        icon
                        size="small"
                        :shadow="lang.primary ? false : true"
                      >
                        <ion-icon
                          :name="lang.icon"
                          :class="[lang.primary ? 'color-2' : 'primary']"
                        ></ion-icon>
                      </vs-button>
                      <template #tooltip>
                        {{ lang.name }}
                      </template>
                    </vs-tooltip>
                  </div>
                </template>
              </vs-card>
            </div>
          </div>

          <div class="more square">
            <div class="box-ratio">
              <vs-card
                type="2"
                data-cursor-hover
                data-cursor-mix-blend-mode="difference"
              >
                <template #img>
                  <img src="/assets/cards/github.png" alt="Github link" />
                </template>
                <template #title>
                  <a
                    class="center-btn"
                    href="https://github.com/WilkerLopes"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ion-icon
                      name="arrow-forward-outline"
                      class="thin large color-2"
                    ></ion-icon>
                  </a>
                </template>
                <template #text>
                  <p></p>
                </template>
              </vs-card>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      projects: [
        {
          id: 1,
          title: "JJGaming",
          description: "Mini plataforma com jogos simples em JS.",
          image: "/assets/cards/jjgaming.png",
          status: "Em desenvolvimento ...",
          link: "https://github.com/WilkerLopes/JJGaming",
          stack: [
            {
              icon: "logo-vue",
              name: "Vue.js",
              primary: true,
            },
            {
              icon: "logo-sass",
              name: "Sass",
              primary: false,
            },
            {
              icon: "logo-github",
              name: "Github",
              primary: false,
            },
          ],
          contributors: [
            {
              name: "Wilker",
              picture: "https://avatars.githubusercontent.com/u/48459835?v=4",
              link: "https://github.com/wilkerlopes",
            },
          ],
        },
        {
          id: 2,
          title: "Biologia Digital",
          description:
            "Site e aplicativo criado para ajudar alunos e professores sobre biologia em sala de aula.",
          image: "/assets/cards/biologia_digital.png",
          status: "",
          link: null,
          stack: [
            {
              icon: "logo-ionic",
              name: "Ionic framework",
              primary: true,
            },
            {
              icon: "logo-angular",
              name: "Angular.js",
              primary: true,
            },
            {
              icon: "logo-android",
              name: "Android",
              primary: false,
            },
            {
              icon: "logo-laravel",
              name: "PHP",
              primary: true,
            },
            {
              icon: "logo-pwa",
              name: "PWA",
              primary: false,
            },
          ],
          contributors: [
            {
              name: "Wilker",
              picture: "https://avatars.githubusercontent.com/u/48459835?v=4",
              link: "https://github.com/wilkerlopes",
            },
            {
              name: "Enos",
              picture: "https://avatars.githubusercontent.com/u/82051875?v=4",
              link: "https://github.com/alien0s",
            },
          ],
        },
        {
          id: 3,
          title: "PokeAPP",
          description:
            "Mini projeto de um pokedex completo, com todos. Feito pra quem ama pokemons. ❤️ Inpiração: https://dribbble.com/shots/6545819-Pokedex-App",
          image: "/assets/cards/pokeapp.jpg",
          status: "Em desenvolvimento ...",
          link: "https://github.com/WilkerLopes/PokeApp",
          stack: [
            {
              icon: "logo-vue",
              name: "Vue.js",
              primary: true,
            },
            {
              icon: "logo-sass",
              name: "Sass",
              primary: false,
            },
            {
              icon: "logo-javascript",
              name: "javascript",
              primary: false,
            },
          ],
          contributors: [
            {
              name: "Wilker",
              picture: "https://avatars.githubusercontent.com/u/48459835?v=4",
              link: "https://github.com/wilkerlopes",
            },
          ],
        },
      ],
      skills: [
        {
          name: "HTML5",
          habilities: "s5",
        },
        {
          name: "SASS",
          habilities: "s5",
        },
        {
          name: "Bootstrap",
          habilities: "s5",
        },
        {
          name: "Javascript",
          habilities: "s5",
        },
        {
          name: "PHP",
          habilities: "s4",
        },
        {
          name: "MySQL",
          habilities: "s4",
        },
        {
          name: "Jquery",
          habilities: "s4",
        },
        {
          name: "Vue.js",
          habilities: "s4",
        },
        {
          name: "Angular.js",
          habilities: "s3",
        },
        {
          name: "Desgin",
          habilities: "s3",
        },
        {
          name: "Ionic",
          habilities: "s3",
        },
		{
          name: "Electron.js",
          habilities: "s3",
        },
      ],
    };
  },
  methods: {
    opemLink(url) {
      window.open(url, "_blank");
    },
  },
  computed: {
    skillsTabs() {
      var list = [[], []];

      for (let index in this.skills) {
        index % 2 == 0
          ? list[0].push(this.skills[index])
          : list[1].push(this.skills[index]);
      }

      return list;
    },
  },
};

// 4+4+4+2+2
</script>

<style lang="scss" src="./Home.scss"></style>
